import { Link } from '@tanstack/react-router';
import { t } from '../i18n/lingua.js';

/**
 * Le voci di menu che esistono ma non aprono ancora niente.
 *
 * Preferisco un menu completo con qualche porta chiusa a un menu che cresce
 * di settimana in settimana: così si vede sempre quanto manca, e nessuno
 * scopre per caso che una sezione non c'è.
 */

const QUANDO: Record<string, string> = {
  Clienti: t('la prossima consegna: elenco con ricerca, viste salvate ed esportazione'),
  Fornitori: t('insieme ai clienti: è lo stesso elenco con un filtro diverso'),
  Agenti: 'insieme ai clienti',
  Lead: 'insieme ai clienti',
  Prospect: 'insieme ai clienti',
  Operatori: 'insieme ai clienti',
  Articoli: t('dopo le anagrafiche, in sola lettura come oggi'),
  Listini: t('dopo gli articoli, con la duplicazione per il trimestre nuovo'),
  Trattative: t('verso la fine: il flusso va disegnato con il cliente'),
  'Ordini di vendita': t('il pezzo grosso: prima in lettura, poi la macchina a stati'),
  Documenti: t('dopo gli ordini, insieme all’archivio dei file'),
  'Dati generici': t('insieme agli articoli: una trentina di anagrafiche con la stessa forma'),
  Integrazioni: t('quando entra in funzione l’agente Business Central'),
};

export function InArrivo({ sezione }: { sezione: string }) {
  return (
    <>
      <div className="page-head">
        <div>
          <h1 className="page-title">{sezione}</h1>
          <div className="page-sub">{t('Questa sezione non è ancora stata costruita')}</div>
        </div>
      </div>

      <div className="cantiere">
        <h2>{t('Arriva più avanti')}</h2>
        <p>{QUANDO[sezione] ?? t('in programma nelle prossime consegne')}.</p>
        <p>
          {t('Il programma completo, tappa per tappa, è nel file')}{' '}
          <span className="num">{t('PIANO-SVILUPPO.md')}</span>.{' '}
          <Link to="/">{t('Torna al mio lavoro')}</Link>
        </p>
      </div>
    </>
  );
}
